export default {
  "divider-container": "n1Ux5",
  "divider-container--double": "pfsU-",
  "divider": "j8rV3",
  "divider--single": "Mhg1L",
  "divider--double": "_9uHgP",
  "divider--dashed": "_5Xlk3",
  "divider--dotted": "Ishdw",
  "divider--small": "_4G1tR",
  "divider--medium": "_5jRyX",
  "divider--large": "ofMVH",
  "divider--left": "BEfLd",
  "divider--center": "fB7vN",
  "divider--right": "sIyza",
  "svgFixerContainer": "PLnm-",
  "emptyChar": "_9A-H3"
};